import { Step as MUIStep, StepContent, StepLabel, Stepper } from '@mui/material';
import { VerticalBox } from '../../../../component/layout/BoxLayout';

export interface Step {
  label: string;
  description: string;
  content: () => React.JSX.Element;
  preview: () => React.JSX.Element;
}

interface Props {
  activeStep: number;
  steps: Step[];
}

const StepOverview: React.FC<Props> = ({ activeStep, steps }) => {
  return (
    <VerticalBox alignItems="center" textAlign="center" gap={2} justifyContent="space-between">
      <Stepper activeStep={activeStep} orientation="vertical">
        {steps.map(({ description, label }) => {
          return (
            <MUIStep key={label}>
              <StepLabel>{label}</StepLabel>
              <StepContent>{description}</StepContent>
            </MUIStep>
          );
        })}
      </Stepper>
    </VerticalBox>
  );
};

export default StepOverview;
